module.exports = __webpack_public_path__ + "img/fob_symbol_green.ba32c083.svg";